export default __webpack_public_path__ + "static/media/circles.a9e6b915.svg";